module.exports = __webpack_public_path__ + "img/fachb.bebb30de.png";